module.exports = __webpack_public_path__ + "static/media/cg.94e94c26.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/cg.jpg
// module id = 5751
// module chunks = 0